import { render } from "./hyadd.vue?vue&type=template&id=22d4e0b1&scoped=true"
import script from "./hyadd.vue?vue&type=script&lang=js"
export * from "./hyadd.vue?vue&type=script&lang=js"

import "./hyadd.vue?vue&type=style&index=0&id=22d4e0b1&lang=scss&scoped=true"
import "./hyadd.vue?vue&type=style&index=1&id=22d4e0b1&scoped=true&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22d4e0b1"]])

export default __exports__